export default __webpack_public_path__ + "static/media/007-cheese.016c1f0b.svg";